import React from "react";
import { MotionProps } from "framer-motion"

import { Row, Col } from "react-bootstrap";
import { Container, Title, SubTitle } from "./styles";
import { IHeader } from "./interface"


export default ({
    subTitle, 
    subTitleWidth, 
    title
}: IHeader
): React.ReactElement => {
    return(
        <Container className="row" layout>
            <Col lg={12}>
                <Title>{title}</Title>
                <div style={{width: subTitleWidth}}>
                    <SubTitle>{subTitle}</SubTitle>
                </div>
            </Col>
        </Container>
    )
}